// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 899px) {
  h2 {
    font-size: 18px;
  }
  .pageTitle img {
    height: 30px;
  }
  .carousel h3 {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    justify-content: left;
    align-items: left;
    font-family: lato, sans-serif;
    font-weight: 600;
    font-style: normal;
    color: #212121;
    font-size: 16px;
    margin: 0 10px 5px 10px;
  }

  .carousel .border,
  .dashedLine {
    border-top: 1px dashed #999999;
    width: 100%;
    height: 1px;
  }
  .carousel .books {
    display: flex;
    flex-flow: column wrap;
    width: 100%;
    height: auto;
    align-items: flex-start;
    justify-content: flex-start;

    margin: 0 20px;
    font-size: 14px;
  }
  .carousel div {
    margin: 10px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./css/900Max.css"],"names":[],"mappings":"AAAA;EACE;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,uBAAuB;EACzB;;EAEA;;IAEE,8BAA8B;IAC9B,WAAW;IACX,WAAW;EACb;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;;IAE3B,cAAc;IACd,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["@media only screen and (max-width: 899px) {\n  h2 {\n    font-size: 18px;\n  }\n  .pageTitle img {\n    height: 30px;\n  }\n  .carousel h3 {\n    display: flex;\n    flex-flow: row nowrap;\n    width: 100%;\n    justify-content: left;\n    align-items: left;\n    font-family: lato, sans-serif;\n    font-weight: 600;\n    font-style: normal;\n    color: #212121;\n    font-size: 16px;\n    margin: 0 10px 5px 10px;\n  }\n\n  .carousel .border,\n  .dashedLine {\n    border-top: 1px dashed #999999;\n    width: 100%;\n    height: 1px;\n  }\n  .carousel .books {\n    display: flex;\n    flex-flow: column wrap;\n    width: 100%;\n    height: auto;\n    align-items: flex-start;\n    justify-content: flex-start;\n\n    margin: 0 20px;\n    font-size: 14px;\n  }\n  .carousel div {\n    margin: 10px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
